module.exports = __webpack_public_path__ + "static/media/css.c9421be5.png";